import { Component, OnInit } from "@angular/core";
import { Disclaimers } from "./disclaimers.interface";
import { GetDisclaimersAction } from "./disclaimers.actions";
import { Store } from "@ngrx/store";
import { getDisclaimersSelector } from "./disclaimers.reducer";
import { MatDialog } from "@angular/material/dialog";
import { DisclaimerAddComponent } from "./disclaimer-add/disclaimer-add.component";

@Component({
  selector: "app-disclaimers",
  templateUrl: "./disclaimers.component.html",
  styleUrls: ["./disclaimers.component.scss"],
  standalone: false,
})
export class DisclaimersComponent implements OnInit {
  disclaimers: Disclaimers;

  constructor(
    private store: Store,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new GetDisclaimersAction());

    this.store
      .select(getDisclaimersSelector)
      .subscribe((disclaimers: Disclaimers) => {
        this.disclaimers = disclaimers;
      });
  }

  showAddForm(): void {
    this.dialog.open(DisclaimerAddComponent, {
      width: "600px",
      disableClose: true,
      panelClass: "app-dialog-panel",
    });
  }
}
